const restaurant = {
  restaurant: "Restaurant", // translated
  restaurants: "Restaurants", // translated
  category: "Catégorie", // translated
  score: "Score", // translated
  priceQuartile: "Quartile de prix", // translated
  scoreLowestFirst: "Score (le plus bas en premier)", // translated
  scoreHighestFirst: "Score (le plus élevé en premier)", // translated
  priceLowestFirst: "Prix: les plus bas en premier)", // translated
  priceHighestFirst: "Prix: le plus élevé en premier)", // translated
  allPrices: "Tous les prix", // translated
  reserve: "Réserve", // translated
  dining: "À manger", // translated
};


export default restaurant;
